import * as XLSX from "xlsx";

/**
 * Downloads a pre-formatted Excel template file for bulk uploads
 * @param {"members" | "donors" | "volunteers"} entityType 
 */
export function downloadExcelTemplate(entityType) {
  let fileName = "";
  let sheetName = "";
  let data = [];

  if (entityType === "members") {
    fileName = "TrustDime_Members_Bulk_Upload_Template.xlsx";
    sheetName = "Members";
    data = [
      {
        "Full Name": "Jane Doe",
        "Email Address": "jane.doe@example.com",
        "Role": "volunteer",
        "Temp Password": "",
      },
      {
        "Full Name": "John Smith",
        "Email Address": "john.smith@example.com",
        "Role": "treasurer",
        "Temp Password": "Password123!",
      },
      {
        "Full Name": "Sarah Jenkins",
        "Email Address": "sarah.j@example.com",
        "Role": "board",
        "Temp Password": "",
      },
    ];
  } else if (entityType === "donors") {
    fileName = "TrustDime_Donors_Bulk_Upload_Template.xlsx";
    sheetName = "Donors";
    data = [
      {
        "Full Name": "Alice Wonder",
        "Email Address": "alice@example.com",
        "Phone Number": "+1 555-0192",
        "Tags": "VIP, Monthly Donor",
        "Notes": "Prefers email communications and annual tax receipts.",
      },
      {
        "Full Name": "Robert Miller",
        "Email Address": "robert.m@example.com",
        "Phone Number": "+1 555-0144",
        "Tags": "Corporate Sponsor",
        "Notes": "Key benefactor for education initiative.",
      },
    ];
  } else if (entityType === "volunteers") {
    fileName = "TrustDime_Volunteers_Bulk_Upload_Template.xlsx";
    sheetName = "Volunteers";
    data = [
      {
        "Full Name": "Carol Danvers",
        "Email Address": "carol.d@example.com",
        "Phone Number": "+1 555-0188",
        "Skills": "Event Management, First Aid, Logistics",
      },
      {
        "Full Name": "David Banner",
        "Email Address": "david.b@example.com",
        "Phone Number": "+1 555-0133",
        "Skills": "Web Development, Graphic Design",
      },
    ];
  }

  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Set column widths for better user experience when opening template
  worksheet["!cols"] = [
    { wch: 24 }, // Full Name
    { wch: 30 }, // Email
    { wch: 20 }, // Role/Phone
    { wch: 25 }, // Password/Tags/Skills
    { wch: 45 }, // Notes
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
}

/**
 * Parses an uploaded Excel file (.xlsx, .xls, .csv) into an array of objects
 * @param {File} file 
 * @returns {Promise<Array<Object>>}
 */
export function parseExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convert sheet to JSON rows with raw headers intact
        const rows = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        resolve(rows);
      } catch (err) {
        reject(new Error("Failed to parse Excel file. Please ensure it is a valid .xlsx, .xls, or .csv file."));
      }
    };

    reader.onerror = () => reject(new Error("Error reading file."));
    reader.readAsArrayBuffer(file);
  });
}
